import { useMutation } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const usePromptLogFeedback = (promptId) => {
  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/prompt-logs/${promptId}/feedback`,
        method: "PUT",
        body: data,
      }),
  });
};
